//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Facet.js";
import "../no/TaggedObjectCollection.js";
import "../no/ugmath.js";
import "../no/BasePart.js";
import "../no/Part.js";
let d=[[],[[["journal_identifier"],"FindObject",{R_:{found:"Facet.FacetedBody"}},1,0],[[],"CreateFacetCurvatureBuilder",{R_:{builder:"Facet.CurvatureBuilder"}},0,0],[[],"CreateFacetFeatureExtractionBuilder",{R_:{builder:"Facet.FeatureExtractionBuilder"}},0,0],[["fromBody","toFacetType"],"Convert",{},2,0],[["fromBody","toPart","toFacetType"],"Copy",{R_:{copy:"Facet.FacetedBody"}},3,0],[["solidBody","nAssociatedFacetedBodies","numberOfUnloadedFacetedBodies"],"GetAssociatedFacetedBodies",{R_:{associatedFacetedBodies:"Facet.FacetedBody[]"}},1,0],[[],"DeleteTemporaryFacesAndEdges",{},0,0],[[],"CreateBestFitAlignBuilder",{R_:{builder:"Facet.BestFitAlignBuilder"}},0,0],[[],"CreateFillHoleBuilder",{R_:{builder:"Facet.FillHoleBuilder"}},0,0],[[],"CreateSTLImportBuilder",{R_:{builder:"Facet.STLImportBuilder"}},0,0],[[],"CreateDecimateFacetBodyBuilder",{R_:{builder:"Facet.DecimateFacetBodyBuilder"}},0,0],[[],"CreateMultiPatchAlignmentBuilder",{R_:{builder:"Facet.MultiPatchAlignmentBuilder"}},0,0],[[],"CreateSubdivideFacetBodyBuilder",{R_:{builder:"Facet.SubdivideFacetBodyBuilder"}},0,0],[[],"CreateSmoothFacetBodyBuilder",{R_:{builder:"Facet.SmoothFacetBodyBuilder"}},0,0],[[],"CreateSnipFacetBodyBuilder",{R_:{builder:"Facet.SnipFacetBodyBuilder"}},0,0],[["solidBodies","facetBodies","errorTable"],"CreateFacetBody",{},1,0],[["solidFaces","facetBodies","errorTable"],"CreateFacetBodyFromFaces",{},1,0],[[],"CreateExtrudeFacetBodyBuilder",{R_:{builder:"Facet.ExtrudeFacetBodyBuilder"}},0,0],[[],"CreateExtrudeProfileBuilder",{R_:{builder:"Facet.ExtrudeProfileBuilder"}},0,0],[[],"CreateMergeFacetBodyBuilder",{R_:{builder:"Facet.MergeFacetBodyBuilder"}},0,1],[[],"CreateBridgeFacetBodyBuilder",{R_:{builder:"Facet.BridgeFacetBodyBuilder"}},0,0],[[],"CreateSewFacetBodyBuilder",{R_:{builder:"Facet.SewFacetBodyBuilder"}},0,0]],[["FacetModelingCollection","Facet.FacetModelingCollection",0]]];
SPLM.Facet.FacetedBodyCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Facet.FacetedBodyCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

SPLM.Facet.FacetingParameters = class{
    constructor(maximumFacetEdges,specifySurfaceTolerance,surfaceDistanceTolerance,surfaceAngularTolerance,specifyCurveTolerance,curveDistanceTolerance,curveAngularTolerance,curveMaximumLength,specifyConvexFacets,specifyMaximumFacetSize,maximumFacetSize,specifyParameters,numberStorageType,specifyViewDirection,silhouetteViewDirection,silhouetteChordTolerance,storeFaceTag,withLODS){
        this.maximumFacetEdges=maximumFacetEdges;this.specifySurfaceTolerance=specifySurfaceTolerance;this.surfaceDistanceTolerance=surfaceDistanceTolerance;this.surfaceAngularTolerance=surfaceAngularTolerance;this.specifyCurveTolerance=specifyCurveTolerance;this.curveDistanceTolerance=curveDistanceTolerance;this.curveAngularTolerance=curveAngularTolerance;this.curveMaximumLength=curveMaximumLength;this.specifyConvexFacets=specifyConvexFacets;this.specifyMaximumFacetSize=specifyMaximumFacetSize;this.maximumFacetSize=maximumFacetSize;this.specifyParameters=specifyParameters;this.numberStorageType=numberStorageType;this.specifyViewDirection=specifyViewDirection;this.silhouetteViewDirection=silhouetteViewDirection;this.silhouetteChordTolerance=silhouetteChordTolerance;this.storeFaceTag=storeFaceTag;this.withLODS=withLODS;}
    get Maximumfacetedges(){return this.maximumFacetEdges}
    set Maximumfacetedges(val){this.maximumFacetEdges = val}
    get Specifysurfacetolerance(){return this.specifySurfaceTolerance}
    set Specifysurfacetolerance(val){this.specifySurfaceTolerance = val}
    get Surfacedistancetolerance(){return this.surfaceDistanceTolerance}
    set Surfacedistancetolerance(val){this.surfaceDistanceTolerance = val}
    get Surfaceangulartolerance(){return this.surfaceAngularTolerance}
    set Surfaceangulartolerance(val){this.surfaceAngularTolerance = val}
    get Specifycurvetolerance(){return this.specifyCurveTolerance}
    set Specifycurvetolerance(val){this.specifyCurveTolerance = val}
    get Curvedistancetolerance(){return this.curveDistanceTolerance}
    set Curvedistancetolerance(val){this.curveDistanceTolerance = val}
    get Curveangulartolerance(){return this.curveAngularTolerance}
    set Curveangulartolerance(val){this.curveAngularTolerance = val}
    get Curvemaximumlength(){return this.curveMaximumLength}
    set Curvemaximumlength(val){this.curveMaximumLength = val}
    get Specifyconvexfacets(){return this.specifyConvexFacets}
    set Specifyconvexfacets(val){this.specifyConvexFacets = val}
    get Specifymaximumfacetsize(){return this.specifyMaximumFacetSize}
    set Specifymaximumfacetsize(val){this.specifyMaximumFacetSize = val}
    get Maximumfacetsize(){return this.maximumFacetSize}
    set Maximumfacetsize(val){this.maximumFacetSize = val}
    get Specifyparameters(){return this.specifyParameters}
    set Specifyparameters(val){this.specifyParameters = val}
    get Numberstoragetype(){return this.numberStorageType}
    set Numberstoragetype(val){this.numberStorageType = val}
    get Specifyviewdirection(){return this.specifyViewDirection}
    set Specifyviewdirection(val){this.specifyViewDirection = val}
    get Silhouetteviewdirection(){if(this.silhouetteViewDirection === undefined) this.silhouetteViewDirection = new SPLM.Vector3d(); return this.silhouetteViewDirection}
    set Silhouetteviewdirection(val){this.silhouetteViewDirection = val}
    get Silhouettechordtolerance(){return this.silhouetteChordTolerance}
    set Silhouettechordtolerance(val){this.silhouetteChordTolerance = val}
    get Storefacetag(){return this.storeFaceTag}
    set Storefacetag(val){this.storeFaceTag = val}
    get Withlods(){return this.withLODS}
    set Withlods(val){this.withLODS = val}
};

SPLM.Facet.FacetedBodyCollection.Type = Object.freeze({
    "Nx" : "Nx", "Jt" : "Jt"});

export default SPLM;